<!DOCTYPE HTML>
<template>
<div class="verification-badge"
     :class="[{'small':small}, {'large':large}]">
  <template v-if="status">
    <img src="@/assets/Verified.png" />
    <div class="label verified"
         v-if="!small || simple">
      Verified
    </div>
  </template>
  <template v-else>
    <img src="@/assets/NotVerified.png" />
    <div class="label"
         v-if="!small || simple">
      Unverified
    </div>
  </template>

</div>
</template>

<script>
export default {
  name: 'Pillgroup',
  props: {
    status: Boolean,
    small: Boolean,
    large: Boolean,
    simple: Boolean,
  },
  data() {
    return {}
  },
  methods: {
    label( item ) {
      if ( item.label ) { return item.label }
      if ( item.text ) { return item.text }
      return item
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/global.scss";

.verification-badge {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: 0.5rem;
    font-size: 0.8rem;

    img {
        width: 2rem;
    }

    &.small {
        img {
            width: 1.5rem;
        }
    }

    &.large {
        img {
            width: 3rem;
        }
    }

    .label {
        color: theme-color-level('primary',-8);

        &.verified {
            color: var(--note);
        }
    }
}
</style>
